import { useParams } from "react-router";
import { ProcessPageMainTemplate } from "../../_components/process-page-main-template";
import {
  BreadcrumbItem,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import { useProcessesProcessShowQuery } from "@/services/backend/processes/api/process-api";
import t from "@/lang/lang";
import { RltBreadcrumbs } from "../_components/rlt-breadcrumbs";
import { CalculationIndexRoute } from "./_components/calculation-index-route";

export function CalculationsRoute() {
  const { processId } = useParams();
  const { data } = useProcessesProcessShowQuery({ id: processId! });

  if (!data) return null;

  const breadcrumbs = (
    <RltBreadcrumbs customerId={data.customerId} processId={data.id}>
      <BreadcrumbSeparator />
      <BreadcrumbItem>
        <BreadcrumbPage>{t("Kalkulationen")}</BreadcrumbPage>
      </BreadcrumbItem>
    </RltBreadcrumbs>
  );

  return (
    <ProcessPageMainTemplate breadcrumbs={breadcrumbs}>
      <CalculationIndexRoute />
    </ProcessPageMainTemplate>
  );
}
